import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { colours, responsiveQuery } from "../../constants/css";
import { Spinner, Heart } from "../_global";
import { toggleFavourite, openLoginModal } from "../../reducers/user";
import HeartWithCircle from "../_global/HeartWithCircle";
var Button = styled.button.withConfig({
  displayName: "CardButton__Button",
  componentId: "sc-1ya47rb-0"
})(["border:none;height:30px;width:30px;position:absolute;right:0;top:0;background-color:transparent;padding:0;text-align:center;z-index:1;", " &:hover{@media only screen and ", " and (hover:hover){cursor:pointer;background:", ";border-radius:50%;}}", " ", " svg{vertical-align:middle;margin-top:2px;}"], function (props) {
  return props.rounded && "\n    background-color: ".concat(colours.qantasWhite, ";\n    border-radius: 50%;\n    right: 5px;\n    top: 5px;\n  ");
}, responsiveQuery.largerThanMobileNew, colours.qantasLightGrey, function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && css(["height:2rem;position:absolute;top:1.25rem;right:1.75rem;"]);
}, function (_ref2) {
  var isMini = _ref2.isMini;
  return isMini && css(["top:-3px;"]);
});
var FavSpinner = styled(Spinner).withConfig({
  displayName: "CardButton__FavSpinner",
  componentId: "sc-1ya47rb-1"
})(["width:1rem;height:1rem;"]);
var CardButton = /*#__PURE__*/function (_Component) {
  function CardButton() {
    var _this;
    _classCallCheck(this, CardButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, CardButton, [].concat(args)), _this.state = {
      isError: false,
      isLoading: false
    }, _this.onClick = function () {
      var _this$props = _this.props,
        merchantId = _this$props.merchantId,
        authorized = _this$props.authorized;
      if (authorized) {
        _this.setState({
          isLoading: true
        });
        return _this.props.toggleFavourite(merchantId).then(function () {
          _this.setState({
            isLoading: false
          });
        }).catch(function () {
          _this.setState({
            isLoading: false,
            isError: true
          });
        });
      }
      _this.props.openLoginModal(window.location.href);
      return null;
    }, _assertThisInitialized(_this)));
  }
  _inherits(CardButton, _Component);
  return _createClass(CardButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isLoading = _this$state.isLoading,
        isError = _this$state.isError;
      var _this$props2 = this.props,
        favourites = _this$props2.favourites,
        merchantId = _this$props2.merchantId,
        rounded = _this$props2.rounded,
        _this$props2$isCircle = _this$props2.isCircleHeart,
        isCircleHeart = _this$props2$isCircle === void 0 ? false : _this$props2$isCircle,
        isMobile = _this$props2.isMobile,
        isMini = _this$props2.isMini,
        merchantName = _this$props2.merchantName;
      return __jsx(Button, {
        onClick: function onClick(e) {
          e.stopPropagation();
          _this2.onClick();
        },
        rounded: rounded,
        isMobile: isMobile,
        isMini: isMini,
        "aria-label": "favourite button for ".concat(merchantName)
      }, isLoading && __jsx(FavSpinner, null), !isLoading && isCircleHeart && __jsx(React.Fragment, null, isMobile ? __jsx(HeartWithCircle, {
        isFilled: !isError && favourites && favourites[merchantId]
      }) : __jsx(Heart, {
        isFilled: !isError && favourites && favourites[merchantId]
      })), !isLoading && !isCircleHeart && __jsx(Heart, {
        isFilled: !isError && favourites && favourites[merchantId]
      }));
    }
  }]);
}(Component);
CardButton.defaultProps = {
  rounded: false,
  authorized: false,
  isMobile: false,
  isMini: false
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$user = _ref3.user,
    authorized = _ref3$user.authorized,
    favourites = _ref3$user.favourites;
  return {
    authorized: authorized,
    favourites: favourites
  };
};
var mapDispatchToProps = {
  toggleFavourite: toggleFavourite,
  openLoginModal: openLoginModal
};
export default connect(mapStateToProps, mapDispatchToProps)(CardButton);